import { Resource } from 'constants/resources';

import { SxProps, Theme } from '@mui/material';
import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { RaRecord } from 'react-admin';
import { Link, LinkProps } from 'react-router-dom';
import { Box } from 'shared/mui/Box';
import { Tooltip } from 'shared/mui/Tooltip';
import { Typography } from 'shared/mui/Typography';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';

import { StyledTypography } from './TooltipTextLinkField.styled';

export type TooltipTextLinkFieldProps = {
  source: string;
  value?: string;
  resource: Resource;
  type: string;
  linkProps?: Omit<LinkProps, 'to'>;
  sx?: SxProps<Theme>;
} & Omit<FunctionFieldProps, 'render'>;

export const TooltipTextLinkField: React.FC<TooltipTextLinkFieldProps> = ({
  source,
  sx,
  resource,
  type,
  value,
  linkProps,
  ...rest
}) => {
  const { createPathWithQuery } = useCreatePathWithQuery();

  return (
    <FunctionField
      render={(record: RaRecord) => {
        return (
          <Box>
            <Tooltip arrow title={<Typography fontSize={12}>{value || record[source]}</Typography>}>
              <Link to={createPathWithQuery({ resource, id: record.id, type })} {...linkProps}>
                <StyledTypography sx={sx}>{value || record[source]}</StyledTypography>
              </Link>
            </Tooltip>
          </Box>
        );
      }}
      {...rest}
    />
  );
};
